<template>
  <div id="zhuHai01">
    <swiper :options="swiperOption"
            ref="zhuHai01Swiper">
      <swiper-slide class="swiperF">
        <div class="swiper-title">珠海一号卫星星座</div>
        <div class="swiper-cont">“珠海一号”卫星星座，是我国首个由民营上市企业发射并运营的商业遥感微纳卫星星座。整个星座由分布在不同轨道的34颗卫星组成，包括视频卫星、高光谱卫星、雷达卫星、高分光学卫星和红外卫星。计划在三年内发射完成，整个星座对特定地区，将实现每天不低于8次的重返次数。</div>
        <div class="swiper-img"><img src="@/assets/zhuHai01/earth.png"
               alt=""></div>
      </swiper-slide>
      <swiper-slide class="swiperF">
        <div class="swiper-title">珠海一号卫星星座</div>
        <div class="satellite-list">
          <div class="OHS1">
            <img src="@/assets/zhuHai01/OHS1.png">
            <p>OHS-2/3</p>
            <p>高光谱卫星</p>
          </div>
          <div class="OVS-2">
            <img src="@/assets/zhuHai01/OVS-2.png">
            <p>OVS-2/3</p>
            <p>视频卫星</p>
          </div>
          <div class="OVS-1">
            <img src="@/assets/zhuHai01/OVS-1.png">
            <p>OVS-1</p>
            <p>视频试验卫星</p>
          </div>
        </div>
        <div class="swiper-listImg"><img src="@/assets/zhuHai01/list.png"
               alt=""></div>
        <div class="swiperBtn">
          <!-- <span @click="goToTrack">卫星实时运行轨道</span> -->
          <span @click="goToExpress">查询星座数据</span>
        </div>
      </swiper-slide>
      <swiper-slide class="swiperF">
        <div class="satellite-img"><img src="@/assets/zhuHai01/OHS1-big.png"
               alt=""></div>
        <div class="satellite-name">OHS-2/OHS-3高光谱卫星</div>
        <div class="satellite-num"><span>在轨8颗</span></div>
        <swiper :options="swiperOptionH1">
          <swiper-slide class="swiperH">
            <div class="timeList">
              <p class="infoTime">OHS-3卫星4颗（西海岸一号、飞天茅台号、高密一号、国缘V9号）2019年9月19日发射成功 <img src="@/assets/zhuHai01/new.png"
                     alt=""></p>
              <p class="infoTime">OHS-2卫星4颗（青科大一号、贵阳一号、OHS-2B、OHS-2D）2018年4月26日发射成功</p>
            </div>
            <p class="infoCont">“珠海一号”高光谱卫星是国内目前唯一完成发射并组网的商用高光谱卫星，也是国内空间分辨率最高、幅宽最大的高光谱卫星，具有体积小、质量轻、高性能的特性。卫星光谱分辨率为2.5nm，空间分辨率为10m，卫星综合指标性能处于国际领先水平，是全球25颗高光谱卫星家族中的重要成员。</p>
          </swiper-slide>
          <swiper-slide class="swiperH">
            <div class="swiperHTable">
              <div class="tHead">卫星参数</div>
              <div class="tBody">
                <div>
                  <span class="label">分辨率：</span>
                  <span class="text">10m</span>
                </div>
                <div>
                  <span class="label">成像范围：</span>
                  <span class="text">150km×2500km</span>
                </div>
                <div>
                  <span class="label">谱段数：</span>
                  <span class="text">32个</span>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide class="swiperH">
            <div class="swiperHTable">
              <div class="tHead">“珠海一号”星座高光谱卫星数据获取能力</div>
              <div class="tBody">
                <p>
                  <span class="point"></span>覆盖面积：1,825,000万平方公里/年。
                </p>
                <p>
                  <span class="point"></span>每秒可获取1184MB数据。
                </p>
                <p>
                  <span class="point"></span>10颗星可获取6.5PB数据
                </p>
                <p>
                  <span class="point"></span>10颗星每2天可覆盖全球一次，每年可覆盖全球182次。
                </p>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-pagination swiper-pagination2"
               slot="pagination"></div>
        </swiper>
      </swiper-slide>
      <swiper-slide class="swiperF">
        <div class="satellite-img"><img src="@/assets/zhuHai01/OVS-2-big.png"
               alt=""></div>
        <div class="satellite-name">OVS-2/OVS-3视频卫星</div>
        <div class="satellite-num"><span>在轨2颗</span></div>
        <swiper :options="swiperOptionH2">
          <swiper-slide class="swiperH">
            <div class="timeList">
              <p class="infoTime">OVS-3卫星1颗（春蕾计划之星）2019年9月19日发射成功 <img src="@/assets/zhuHai01/new.png"
                     alt=""></p>
              <p class="infoTime">OVS-2卫星1颗 2018年4月26日发射成功</p>
            </div>
            <p class="infoCont">OVS-2视频卫星运行轨道为98°太阳同步轨道，轨道高度为500km，质量87kg，空间分辨率为0.9m，是同类视频卫星中的性价比最高的。OVS-2视频卫星以凝视模式对地物进行拍摄时，可形成120s的视频影像；推扫成像时，可对目标区域形成宽22.5km、最大扫视范围2500km的卫星影像。</p>
          </swiper-slide>
          <swiper-slide class="swiperH">
            <div class="swiperHTable">
              <div class="tHead">卫星参数</div>
              <div class="tBody">
                <div>
                  <span class="label">分辨率：</span>
                  <span class="text">0.9m</span>
                </div>
                <div>
                  <span class="label">成像范围：</span>
                  <span class="text">视频：4.5km(1~5)×2.7km@500km <br>图像：22.5km×2500km@500km</span>
                </div>
                <div>
                  <span class="label">成像方式：</span>
                  <span class="text">凝视 + 推扫</span>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide class="swiperH">
            <div class="swiperHTable">
              <div class="tHead">OVS-2/3视频卫星成像模式数据获取能力</div>
              <div class="tBody">
                <p>
                  <span class="point"></span>单颗星单景覆盖面积为22.5km x 2.7km，约60.75平方公里。8.1km x 6.1km，约49.4平方公里。
                </p>
                <p>
                  <span class="point"></span>每颗星每秒可拍4景，每秒可获取1008MB数据。

                </p>
                <p>
                  <span class="point"></span>10颗星每年可获取4PB数据
                </p>
                <p>
                  <span class="point"></span>10颗星每12天可覆盖全球一次，每年可覆盖全球30次。
                </p>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-pagination swiper-pagination3"
               slot="pagination"></div>
        </swiper>
      </swiper-slide>
      <swiper-slide class="swiperF">
        <div class="satellite-img"><img src="@/assets/zhuHai01/OVS-1-big.png"
               alt=""></div>
        <div class="satellite-name">OVS-1视频实验卫星</div>
        <div class="satellite-num"><span>在轨2颗</span></div>
        <swiper :options="swiperOptionH3">
          <swiper-slide class="swiperH">
            <div class="timeList">
              <p class="infoTime">OVS-1卫星2颗 2017年6月15日发射成功</p>
            </div>
            <p class="infoCont">OVS-1A/B视频试验卫星是“珠海一号”微纳卫星星座首发的两颗卫星，具有姿态指向及控制精度高、机动能力强的特点。两颗卫星均配套1200万像素的CMOS传感器视频相机，镜片面形精度达0.008μm，支持推扫、凝视两种成像模式，能实现视频影像拍摄和图像影像拍摄。</p>
          </swiper-slide>
          <swiper-slide class="swiperH">
            <div class="swiperHTable">
              <div class="tHead">卫星参数</div>
              <div class="tBody">
                <div>
                  <span class="label">分辨率：</span>
                  <span class="text">1.9m</span>
                </div>
                <div>
                  <span class="label">成像范围：</span>
                  <span class="text">视频：8.1km×6.1km@530km<br>图像：8.1km×6.1km@530km</span>
                </div>
                <div>
                  <span class="label">成像方式：</span>
                  <span class="text">凝视 + 推扫</span>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide class="swiperH">
            <div class="swiperHTable">
              <div class="tHead">OVS-1视频卫星成像模式数据获取能力</div>
              <div class="tBody">
                <p>
                  <span class="point"></span>单颗星单景覆盖面积为8.1km x 6.1km，约49.4平方公里。
                </p>
                <p>
                  <span class="point"></span>每颗星每秒可拍2景，每秒可获取72MB数据。
                </p>
                <p>
                  <span class="point"></span>2颗星每年可获取58TB数据。
                </p>
                <p>
                  <span class="point"></span>每年10颗星可获取9.2PB数据。
                </p>
                <p>
                  <span class="point"></span>2颗星每156天可覆盖全球一次，每年可覆盖全球2次。
                </p>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-pagination swiper-pagination4"
               slot="pagination"></div>
        </swiper>
      </swiper-slide>
      <swiper-slide class="swiperF">
        <div class="mapImg"><img src="@/assets/zhuHai01/mapImg1.png"
               alt=""></div>
        <div class="mapTitle">地面站建设规划</div>
        <div class="mapCont">欧比特公司计划在国内建设6个地面站，分别分布于西北、华北、东北、西南、华南、华东区域，每个地面站包含1-2套天线，其中华南区域地面站位于欧比特科技园内（已建成）；东北漠河地面站于2017年10月完成。此外，还计划在爱尔兰建设地面站。</div>
        <div class="mapParameter">
          <p>
            <span class="point"></span>地面站数量：7个（国外1个）
          </p>
          <p>
            <span class="point"></span>每年接收数据总量：4-6PB
          </p>
          <p>
            <span class="point"></span>测量波段：U/V、X、S
          </p>
          <p>
            <span class="point"></span>数据接收速率：450Mbps（珠海）1.2Gbps（漠河）
          </p>
        </div>
      </swiper-slide>
      <swiper-slide class="swiperF">
        <div class="mapImg"><img src="@/assets/zhuHai01/mapImg2.png"
               alt=""></div>
        <div class="mapTitle">地面站覆盖能力</div>
        <div class="mapCont">西北、东北和珠海地面站接收范围及轨道覆盖；针对没颗卫星，每天有8轨的接收机会。其中有4轨可接收数据时间达10分钟以上。结合欧比特地面大数据中心的高效处理能力，能够实现指令上得去、数据下得来、处理迅速、发布及时的设计目标。</div>
        <div class="mapParameter">
          <p>
            <span class="point"></span>橙色圆圈为地面可接收数据的范围
          </p>
          <p>
            <span class="point"></span>青色曲线代表1颗卫星1天的轨道覆盖情况
          </p>
        </div>
      </swiper-slide>
      <swiper-slide class="swiperF">
        <div class="swiper-title">珠海一号卫星大数据应用</div>
        <div class="swiperSlideList">
          <div v-for="item in cont_list"
               :key="item.src"
               @click="gotoIndustry(item)">
            <img :src="item.src"
                 alt="">
            <p>{{item.title}}</p>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination swiper-pagination1"
           slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import imgSrc1 from '@/assets/content/industry-list-1.jpg'
import imgSrc2 from '@/assets/content/industry-list-2.jpg'
import imgSrc3 from '@/assets/content/industry-list-3.jpg'
import imgSrc4 from '@/assets/content/industry-list-4.jpg'
import imgSrc5 from '@/assets/content/industry-list-5.jpg'
import imgSrc6 from '@/assets/content/industry-list-6.jpg'
export default {
  name: 'zhuHai01',
  data: function () {
    const self = this;
    return {
      cont_list: Object.freeze([
        { id: 1, src: imgSrc1, title: '湖库（地表水）环境遥感监测方案' },
        { id: 2, src: imgSrc2, title: '农业保险遥感监测服务方案' },
        { id: 3, src: imgSrc3, title: '农业保险遥感应用服务方案' },
        { id: 4, src: imgSrc4, title: '林业遥感监测业务化云服务系统建设方案' },
        { id: 5, src: imgSrc5, title: '环境保护遥感方案' },
        { id: 6, src: imgSrc6, title: '城市违章建筑遥感应用' },
      ]),
      swiperActiveIndex: 0,
      swiperOption: {
        direction: 'vertical',
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 1000,
        mousewheel: true,
        followFinger: false,
        pagination: {
          el: '.swiper-pagination1',
          clickable: true
        },
        on: {
          slideChangeTransitionStart: function () {
            self.swiperActiveIndex = this.activeIndex;
          },
        }
      },
      swiperOptionH1: {
        speed: 1000,
        // loop: true,
        // autoplay: {
        //   delay: 5000,
        //   disableOnInteraction: false
        // },
        pagination: {
          el: '.swiper-pagination2',
          clickable: true
        }
      },
      swiperOptionH2: {
        speed: 1000,
        // loop: true,
        // autoplay: {
        //   delay: 5000,
        //   disableOnInteraction: false
        // },
        pagination: {
          el: '.swiper-pagination3',
          clickable: true
        }
      },
      swiperOptionH3: {
        speed: 1000,
        // loop: true,
        // autoplay: {
        //   delay: 5000,
        //   disableOnInteraction: false
        // },
        pagination: {
          el: '.swiper-pagination4',
          clickable: true
        }
      },
    }
  },
  mounted () {
    if (this.$route.params.index) {
      this.$refs.zhuHai01Swiper.$swiper.slideTo(this.$route.params.index, 0);
    }
  },
  methods: {
    goToExpress () {
      this.$router.push({
        name: 'dataExpress'
      })
    },
    goToTrack () {
      this.$router.push({
        name: 'dataExpress',
        params: {
          type: 'track'
        }
      })
    },
    gotoIndustry (item) {
      this.$router.push({
        name: 'industry',
        params: {
          id: item.id,
          title: item.title
        }
      })
    }
  }
}

</script>

<style scoped>
#zhuHai01 {
  width: 100%;
  height: 100%;
  background: url("~@/assets/zhuHai01/bg.png") 0 0 no-repeat;
  background-size: cover;
}
#zhuHai01 > .swiper-container {
  height: 100%;
}
.swiperF {
  padding-top: 60px;
  position: relative;
  box-sizing: border-box;
}
.swiperF .swiper-container {
  padding-bottom: 20px;
}
.swiperF .swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 0;
}
.swiperF .swiper-pagination-bullet {
  width: 50px;
  height: 4px;
  border-radius: 1px;
  background-color: #4d4d55;
  opacity: 0.8;
}
.swiperF .swiper-pagination-bullet-active {
  background-color: #fff;
}
.swiper-title {
  font-size: 24px;
  color: #fff;
  text-align: center;
  line-height: 70px;
}
.swiper-cont {
  width: 80%;
  font-size: 14px;
  color: #fff;
  line-height: 26px;
  margin: 0 auto;
}
.swiper-img {
  position: absolute;
  bottom: 0;
  width: 80%;
  left: 10%;
  font-size: 0;
}
.swiper-listImg {
  position: absolute;
  bottom: 120px;
  width: 70%;
  left: 15%;
  font-size: 0;
}
.swiper-listImg img {
  width: 100%;
}
.swiper-img img {
  width: 100%;
}
.satellite-list {
  display: flex;
  align-items: center;
  justify-content: space-around;
  color: #fff;
  font-size: 14px;
}
.satellite-list .OHS1 img {
  width: 58px;
  margin-bottom: 1px;
}
.satellite-list .OVS-2 img {
  width: 50px;
  margin-bottom: 16px;
}
.satellite-list .OVS-1 img {
  width: 70px;
}
.satellite-list p {
  line-height: 24px;
  text-align: center;
}
.swiperBtn {
  position: absolute;
  width: 100%;
  bottom: 0;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.swiperBtn span {
  font-size: 14px;
  padding: 8px 12px;
  border: 1px solid #ddd;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
}
#zhuHai01 .swiper-pagination1 .swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  position: relative;
  left: -3px;
  opacity: 1;
  background-color: #4d4d55;
}
#zhuHai01
  .swiper-container-vertical
  > .swiper-pagination-bullets.swiper-pagination1
  .swiper-pagination-bullet {
  margin: 30px 0;
}
#zhuHai01 .swiper-pagination1 .swiper-pagination-bullet-active {
  border: 2px solid rgba(52, 209, 188, 0.5);
  left: -5px;
}
#zhuHai01 .swiper-pagination1 .swiper-pagination-bullet-active::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 50%;
  width: 8px;
  height: 8px;
  background-color: #34d1bc;
}
#zhuHai01
  .swiper-container-vertical
  > .swiper-pagination-bullets.swiper-pagination1 {
  right: 10px;
  background-color: rgba(255, 255, 255, 0.3);
  width: 2px;
}
.timeList {
  margin: 10px 0;
}
.infoTime {
  width: 80%;
  margin: 0 auto;
  font-size: 12px;
  line-height: 24px;
  color: #efbd10;
  text-align: center;
}
.infoTime img {
  width: 26px;
  margin-left: 5px;
}
.infoCont {
  width: 80%;
  margin: 0 auto;
  font-size: 12px;
  line-height: 24px;
  color: #fff;
}
.satellite-img {
  width: 30%;
  margin: 20px auto;
}
.satellite-img img {
  width: 100%;
}
.satellite-name {
  font-size: 18px;
  color: #fff;
  text-align: center;
}
.satellite-num {
  text-align: center;
  margin: 30px 0;
}
.satellite-num span {
  font-size: 12px;
  padding: 4px 18px;
  border: 1px solid #34d1bc;
  color: #34d1bc;
  border-radius: 20px;
}
.swiperHTable {
  width: 86%;
  margin: 0 auto;
  border: 1px solid rgba(255, 255, 255, 0.5);
  height: 250px;
}
.tHead {
  font-size: 14px;
  color: #fff;
  line-height: 40px;
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  background: linear-gradient(
    270deg,
    rgba(33, 126, 221, 0.7),
    rgba(48, 230, 198, 0.7)
  );
}
.tBody {
  height: 220px;
  padding: 20px;
  box-sizing: border-box;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.tBody > div {
  display: flex;
  font-size: 12px;
  line-height: 24px;
}
.tBody p {
  display: flex;
  font-size: 12px;
  line-height: 24px;
  align-items: center;
}
.tBody p .point {
  display: inline-block;
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #34d1bc;
  margin-right: 10px;
}
.mapImg {
  width: 86%;
  margin: 10px auto;
}
.mapImg img {
  width: 100%;
}
.mapTitle {
  font-size: 18px;
  line-height: 60px;
  color: #fff;
  text-align: center;
}
.mapCont {
  font-size: 12px;
  line-height: 24px;
  width: 86%;
  margin: 10px auto;
  color: #fff;
}
.mapParameter {
  width: 86%;
  margin: 10px auto;
  color: #fff;
}
.mapParameter p {
  display: flex;
  font-size: 12px;
  line-height: 24px;
  align-items: center;
}
.mapParameter .point {
  display: inline-block;
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #34d1bc;
  margin-right: 10px;
}
.swiperSlideList {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}
.swiperSlideList > div {
  width: 48%;
  padding: 4px;
  box-sizing: border-box;
  flex-shrink: 0;
  margin-bottom: 10px;
  background: rgba(0, 0, 0, 0.8);
  border: 1px solid rgba(255, 255, 255, 1);
  border-radius: 3px;
  cursor: pointer;
}
.swiperSlideList > div img {
  width: 100%;
}
.swiperSlideList p {
  text-align: center;
  font-size: 12px;
  line-height: 24px;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  white-space: nowrap;
}
</style>
